import React from 'react';
import { useNavigate } from 'react-router-dom';

const CustomizeHeader = ({ text = "" }) => {
  const navigate = useNavigate()
  return (
    <div>
      <div className='customize-header'>
        <div className="w-full flex items-center p-24">
          {/* Back Button */}
          <button onClick={() => navigate(-1)} className="text-black text-sm md:text-base">&larr; Back</button>
          <div className="flex-1 text-center">
            <h1 className="text-lg md:text-2xl font-semibold text-black m-0">{text || ""}</h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomizeHeader; 